<template>
	<el-dialog title="提示" :visible.sync="visible" :close-on-click-modal="false" :before-close="beforeClose" width="400px">
		<p class="font-h4-regular yx-color-text-primary">
			操作成功，请在
			<span class="yx-color-primary cursor-pointer" @click="handleCancel">取消认领记录</span>
			查看取消认领进度
		</p>
		<div slot="footer" class="footer-dialog">
			<el-button type="primary" @click="beforeClose">我知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	props: {
		platform_id: {
			type: [Number, String],
			default: '1',
		},
	},
	data() {
		return {
			visible: false,
			id: '',
			type: 'single',
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		handleCancel() {
			this.$emit('refresh');
			this.beforeClose();
		},
		beforeClose() {
			this.visible = false;
		},
	},
};
</script>
